import { Routes } from '@angular/router';

export const dashboardRoutes: Routes = [
  {
    path: '',
    redirectTo: 'assignments',
    pathMatch: 'full',
  },
  {
    path: 'lesson-plans',
    loadComponent: () =>
      import('./lesson-plans/lesson-plans.component').then((m) => m.DashboardLessonPlansComponent),
  },
  {
    path: 'assignments',
    loadComponent: () =>
      import('./assignments/assignments.component').then((m) => m.DashboardAssignmentsComponent),
  },
  {
    path: 'grading',
    loadComponent: () =>
      import('./grading/grading.component').then((m) => m.DashboardGradingComponent),
  },
];
